var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-footer',{staticClass:"shadow",attrs:{"id":"footer"}},[_c('span',[_vm._v(" © 2018-2019 WTA TOUR, INC. | WTA AND THE WTA LOGO ARE TRADEMARKS OF THE WTA TOUR, INC. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }